// Reuses the stopword set from sanitizeShareText.ts — the single authoritative
// list in this codebase, so filtering behaviour is consistent everywhere.
import { STOPWORDS } from './sanitizeShareText'

/**
 * Split OCR quick-lookup text into content words by stripping punctuation and
 * filtering stopwords.  Returns surface forms (not lemmatized — lemmatization
 * happens server-side when each word is submitted to /api/v1/lookup/add/).
 *
 * The return value drives the disambiguation decision:
 *   0 words → treat as empty result
 *   1 word  → single-word lookup (existing path, no disambiguation shown)
 *   2+ words → show OcrDisambiguatePanel
 */
export function tokenizeOcrPhrase(text: string): string[] {
  return text
    .split(/\s+/)
    .map(t => t.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, ''))
    .filter(t => t.length > 0 && !STOPWORDS.has(t.toLowerCase()))
}
